import { createFileRoute } from '@tanstack/react-router'
import { DitheredBlobAvatar, VisitorAvatar } from 'features/visitorDetails'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/visitors/avatars')({
  component: VisitorAvatarsPage,
})

const VISITOR_IDS = [
  'Ry0vc5LOdO0MczoTw6LR',
  'I0GoTCndoLnbA3G9gjF7',
  'V223MP5deus0k65v93BX',
  'GXIPyW79SeA0Wb5OKlUE',
  'J3ngNvdR7BIow0HlEUW7',
  '9u2rORbvNdqVv2Gj0unz',
  'b62ZmKYn0MbFFYsm1J9F',
  '4RZAWmXNMSfAaa2Hpe3e',
  '1LSx58o0gk56YUFUWawW',
  'xnshJlBNRbnOLlJXmWAN',
  'qAT3igo0qdUoxqonG417',
  'EX5rKtQqqJI1IwYp3v0x',
  'qjAAg6L06SCtXvlaeqhn',
  'jV49C5llSsW308inVCfb',
  'YEb0A6hCmVUoqFwKz6yd',
  'oa8LI08z04yaOOwqbS4p',
  'HYf4OIi0I8T0W188Tdla',
  'NxLq0GHQPcQD4XlUu1WR',
  'rGIRJdb6NM037oND0y3z',
  'FMQNZNdQJ402eOSa8dFZ',
]

const SIZE = 48

function VisitorAvatarsPage() {
  return (
    <div className='p-8'>
      <h1 className='mb-6 text-2xl font-bold'>Visitor Avatar Variants</h1>

      <div className='space-y-4'>
        {VISITOR_IDS.map((visitorId) => (
          <div key={visitorId} className='flex items-center gap-4 rounded-lg border border-gray-200 p-4'>
            <code className='w-48 shrink-0 font-mono text-sm text-gray-600'>{visitorId}</code>

            {/* Original VisitorAvatar */}
            <div className='flex flex-col items-center gap-1'>
              <VisitorAvatar seed={visitorId} size={SIZE} />
              <span className='text-xs text-gray-500'>Original</span>
            </div>

            {/* Dithered: Bayer 2/4 */}
            <div className='flex flex-col items-center gap-1'>
              <DitheredBlobAvatar seed={visitorId} size={SIZE} pattern='bayer' ditherSize={2} pixelRatio={4} />
              <span className='text-xs text-gray-500'>Bayer 2/4</span>
            </div>

            {/* Dithered: Bayer 4/4 */}
            <div className='flex flex-col items-center gap-1'>
              <DitheredBlobAvatar seed={visitorId} size={SIZE} pattern='bayer' ditherSize={4} pixelRatio={4} />
              <span className='text-xs text-gray-500'>Bayer 4/4</span>
            </div>

            {/* Dithered: Halftone 4/4 */}
            <div className='flex flex-col items-center gap-1'>
              <DitheredBlobAvatar seed={visitorId} size={SIZE} pattern='halftone' ditherSize={4} pixelRatio={4} />
              <span className='text-xs text-gray-500'>Halftone 4/4</span>
            </div>

            {/* Dithered: Bayer 3/4 circle */}
            <div className='flex flex-col items-center gap-1'>
              <DitheredBlobAvatar
                seed={visitorId}
                size={SIZE}
                pattern='bayer'
                ditherSize={3}
                pixelRatio={4}
                shape='circle'
              />
              <span className='text-xs text-gray-500'>Bayer 3/4 circle</span>
            </div>

            {/* Dithered: Halftone 3/4 circle */}
            <div className='flex flex-col items-center gap-1'>
              <DitheredBlobAvatar
                seed={visitorId}
                size={SIZE}
                pattern='halftone'
                ditherSize={3}
                pixelRatio={4}
                shape='circle'
              />
              <span className='text-xs text-gray-500'>Halftone 3/4 circle</span>
            </div>

            {/* Dithered: Bayer 6/4 */}
            <div className='flex flex-col items-center gap-1'>
              <DitheredBlobAvatar seed={visitorId} size={SIZE} pattern='bayer' ditherSize={6} pixelRatio={4} />
              <span className='text-xs text-gray-500'>Bayer 6/4</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
